module.exports = __webpack_public_path__ + "media/images/emotions/sebastiao-sadness-aa7362a205d6bcb080c252af02399615.svg";